const MAP_EMBED =
	"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d94740.8598637305!2d-88.06815729416883!3d42.09350791224652!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fba3bce5cfa37%3A0xd764707ce5fdcac3!2sArlington%20Heights%2C%20IL!5e0!3m2!1s{lang}!2sus!4v1736375302428!5m2!1s{lang}!2sus";

const MAP_OPEN_URL =
	"https://www.google.com/maps/search/?api=1&query=Arlington+Heights,+IL+60004,+USA";

const CLICKS_EN = {
	asideTitle: "Other ways to reach us",
	phoneHeading: "Phone",
	phoneLink: "Contact us by phone",
	whatsappHeading: "WhatsApp",
	whatsappLink: "Message us on WhatsApp",
	emailHeading: "Email",
	emailLink: "Send us an email",
	addressHeading: "Address",
	addressLine1: "Technical Union",
	addressLine2: "Arlington Heights, IL 60004",
	addressLine3: "USA",
	modalTitle: "Almost there",
	modalBody: "Please enter your name so we can better assist you:",
	modalPlaceholder: "Your name",
	modalCancel: "Cancel",
	modalContinue: "Continue",
	modalAlertName: "Please enter your name",
	whatsappMessage: (name) =>
		`Hi! My name is ${name}. I found your contact on the website.`,
};

const CLICKS_ES = {
	asideTitle: "Otras formas de contacto",
	phoneHeading: "Teléfono",
	phoneLink: "Contáctenos por teléfono",
	whatsappHeading: "WhatsApp",
	whatsappLink: "Escríbanos por WhatsApp",
	emailHeading: "Correo",
	emailLink: "Escríbanos por correo electrónico",
	addressHeading: "Dirección",
	addressLine1: "Technical Union",
	addressLine2: "Arlington Heights, IL 60004",
	addressLine3: "Estados Unidos",
	modalTitle: "Un momento",
	modalBody: "Por favor, indíquenos su nombre para poder atenderle mejor:",
	modalPlaceholder: "Su nombre",
	modalCancel: "Cancelar",
	modalContinue: "Continuar",
	modalAlertName: "Por favor, introduzca su nombre.",
	whatsappMessage: (name) =>
		`¡Buenos días! Mi nombre es ${name}. Le escribo desde el sitio web de Technical Union.`,
};

const FORM_ES = {
	formHeading: "Estimado cliente: le damos la bienvenida.",
	formIntro:
		"Complete el siguiente formulario y nos pondremos en contacto con usted a la brevedad.",
	labelFirstName: "Nombre",
	placeholderFirstName: "Su nombre",
	labelLastName: "Apellidos",
	placeholderLastName: "Sus apellidos",
	labelCompany: "Empresa",
	placeholderCompany: "Nombre de su empresa (opcional)",
	labelEmail: "Correo electrónico",
	placeholderEmail: "Su correo electrónico",
	labelPostalCode: "Código postal",
	placeholderPostalCode: "Código postal",
	labelCountry: "País",
	placeholderCountry: "Su país",
	labelMessage: "Mensaje",
	placeholderMessage: "Describa su consulta o los productos de su interés",
	labelConsentQuestion: "¿Desea que Technical Union (TU) le contacte?",
	consentYes: "Sí, me gustaría que Technical Union (TU) me contacte sobre productos, servicios y novedades de la empresa.",
	consentNo: "No, no deseo recibir este tipo de comunicaciones.",
	submitSending: "Enviando…",
	submitButton: "Enviar",
	requiredMark: "*",
	alertFirstName: "Por favor, introduzca su nombre.",
	alertLastName: "Por favor, introduzca sus apellidos.",
	alertMessage: "Por favor, introduzca su mensaje.",
	alertConsent: "Por favor, indique si desea recibir información sobre productos.",
	alertEmail: "Por favor, introduzca un correo electrónico válido.",
	alertCountry: "Por favor, introduzca su país.",
	alertPostalCode: "Por favor, introduzca su código postal.",
	alertSubmitFail: "No se pudo enviar el formulario. Inténtelo de nuevo más tarde.",
	alertError: "Se produjo un error. Inténtelo de nuevo más tarde.",
};

export const CONTACT_PAGE = {
	en: {
		lang: "en",
		pageTitle: "TU - Technical Union | Contact us",
		metaDescription: "Contact Technical Union for quotes, technical support, and industrial supply.",
		metaKeywords: "tu, contact, quote, hydraulics, Technical Union",
		ogTitle: "TU | Contact us",
		ogDescription: "Contact form and ways to reach Technical Union.",
		ogUrl: "https://www.tu.biz/en/contact-us",
		twitterTitle: "TU | Contact us",
		twitterDescription: "Reach Technical Union for industrial product and support needs.",
		title: "Contact us",
		intro: "Use the form below or choose how you would like to reach us.",
		mapTitle: "Find us on Google Maps",
		mapSrc: MAP_EMBED.replace(/\{lang\}/g, "en"),
		mapOpenUrl: MAP_OPEN_URL,
		mapLoadLabel: "Load interactive map",
		mapOpenLabel: "Open in Google Maps",
		clicks: CLICKS_EN,
		form: null,
	},
	es: {
		lang: "es",
		pageTitle: "TU - Technical Union | Contáctenos",
		metaDescription:
			"Póngase en contacto con Technical Union para cotizaciones, soporte técnico y suministro industrial.",
		metaKeywords: "tu, contacto, cotización, hidráulica, Technical Union",
		ogTitle: "TU | Contáctenos",
		ogDescription: "Formulario de contacto y datos de Technical Union.",
		ogUrl: "https://www.tu.biz/es/contactenos",
		twitterTitle: "TU | Contáctenos",
		twitterDescription: "Contacte a Technical Union para sus necesidades industriales.",
		title: "Contáctenos",
		intro:
			"Complete el formulario o elija la forma de contacto que prefiera.",
		mapTitle: "Ubicación en Google Maps",
		mapSrc: MAP_EMBED.replace(/\{lang\}/g, "es"),
		mapOpenUrl: MAP_OPEN_URL,
		mapLoadLabel: "Cargar mapa interactivo",
		mapOpenLabel: "Abrir en Google Maps",
		clicks: CLICKS_ES,
		form: FORM_ES,
	},
};

export { CLICKS_EN as DEFAULT_CONTACT_CLICKS_COPY };
